jQuery(document).ready(function ($) {
    // Add custom class to Yoast FAQ block
    $('.wp-block-yoast-faq-block').addClass('fcp-faq');

    // Toggle class for FAQ question click
    $('.wp-block-yoast-faq-block .schema-faq-question').click(function () {
        $(this).parent().toggleClass('fcp-opened');
    });

    // Skip animations inside WordPress block editor
    const isEditor = typeof wp !== 'undefined' && wp.data?.select('core/edit-post');

  if (!isEditor) {
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    const animationMap = {
      'slide-up': {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: 'power2.out',
      },
      'fade-in': {
        opacity: 0,
        duration: 1,
        ease: 'power2.out',
      },
      // Add more later:
      // 'zoom-in': { opacity: 0, scale: 0.8, duration: 1, ease: 'back.out(1.7)' },
    };

    document.querySelectorAll('.scroll-animate').forEach((el) => {
      const type = Object.keys(animationMap).find((cls) =>
        el.classList.contains(cls)
      );

      if (!type) return; // no matching animation type

      const base = {
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          end: 'bottom 10%',
          toggleActions: 'play none none none',
        },
      };

      gsap.from(el, { ...base, ...animationMap[type] });
    });
  } else {
    console.warn('❌ GSAP or ScrollTrigger not available');
  }
}

});
